export default "__VITE_ASSET__f913a1e4__"